import React, {Component} from 'react';
class AfterSubmission extends Component {
	render(){
		return (
		<div className = 'app' >
	       		
        	<div className = 'contentbox'>
        		
	       		<h1> {this.props.display} </h1>
          		<hr/>
          		<p> {this.props.display2} </p>
	        </div>
	       
	     </div>
		)
	}
}

export default AfterSubmission ; 